import { render, staticRenderFns } from "./getGift.vue?vue&type=template&id=56102543&scoped=true&"
import script from "./getGift.vue?vue&type=script&lang=js&"
export * from "./getGift.vue?vue&type=script&lang=js&"
import style0 from "./getGift.vue?vue&type=style&index=0&id=56102543&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56102543",
  null
  
)

export default component.exports